export const viewAssignmentsCss = {
  root: {
    justifyContent: "center",
    marginTop: "1.5rem",
    width: "100%",
  },
  Icon: {
    root: {
      "--icon-stroke-width": 3,
    },
  },
};
